module.exports = __webpack_public_path__ + "img/yijiakefu.0521c68b.jpg";